// dev-portal/src/constants/writebackPayloads.js
// Expected payload schemas for each writeback event type

export const WRITEBACK_PAYLOAD_SCHEMAS = {
  // Patient Events
  "patient.record.created": {
    event_type: "patient.record.created",
    subscriber_id: "YOUR_SUBSCRIBER_ID",
    data: {
      first_name: "John",
      last_name: "Doe",
      email: "johndoe@example.com",
      mobile: "1234567890",
      mobile_code: "1",
      gender: "male",
      dob: "1990-05-15",
      address: "123 Main St, Los Angeles, CA 90001, USA",
      suite_number: "",
      dependent_list: [
        {
          first_name: "Emma",
          last_name: "Doe",
          email: "emma.doe@example.com",
          mobile_no: "1234567890",
          mobile_code: "1",
          gender: "Female",
          dob: "2019-01-24",
          realtionship: "Daughter"
        }
      ]
    }
  },
  "patient.record.updated": {
    event_type: "patient.record.updated",
    data: {
      patient_id: "pat_123456",
      full_name: "John Doe",
      email: "johndoe@example.com",
      phone_number: "1234567890",
      date_of_birth: "1990-05-15",
      gender: "male",
      address: "456 Oak Ave, Los Angeles, CA, United States - 90002",
      services: ["implants", "dentures"],
      updated_fields: ["address", "services"]
    }
  },
  "patient.record.deleted": {
    event_type: "patient.record.deleted",
    data: {
      patient_id: "pat_123456",
      reason: "Patient request"
    }
  },

  // User Events
  "user.signup": {
    event_type: "user.signup",
    data: {
      user_id: "usr_123456",
      email: "newuser@example.com",
      full_name: "Jane Smith",
      role: "patient",
      created_at: "2026-03-31T10:30:00Z"
    }
  },
  "user.updated": {
    event_type: "user.updated",
    data: {
      user_id: "usr_123456",
      email: "jane.smith@example.com",
      full_name: "Jane Smith",
      updated_fields: ["email"]
    }
  },
  "user.deleted": {
    event_type: "user.deleted",
    data: {
      user_id: "usr_123456",
      reason: "Account closure request"
    }
  },

  // Case Events
  "case.created": {
    event_type: "case.created",
    data: {
      case_id: "case_123456",
      patient_id: "pat_123456",
      provider_id: "prov_789",
      case_type: "implant_consultation",
      status: "open",
      description: "Initial consultation for dental implant",
      created_at: "2026-03-31T10:30:00Z"
    }
  },
  "case.updated": {
    event_type: "case.updated",
    data: {
      case_id: "case_123456",
      patient_id: "pat_123456",
      status: "in_progress",
      notes: "Treatment plan approved",
      updated_fields: ["status", "notes"]
    }
  },
  "case.closed": {
    event_type: "case.closed",
    data: {
      case_id: "case_123456",
      patient_id: "pat_123456",
      resolution: "completed",
      closed_at: "2026-03-31T15:00:00Z"
    }
  },

  // Appointment Events
  "appointment.booked": {
    event_type: "appointment.booked",
    data: {
      appointment_id: "apt_123456",
      patient_id: "pat_123456",
      provider_id: "prov_789",
      service_type: "dental_checkup",
      scheduled_at: "2026-04-05T09:00:00Z",
      duration_minutes: 30,
      location: "Main Clinic"
    }
  },
  "appointment.rescheduled": {
    event_type: "appointment.rescheduled",
    data: {
      appointment_id: "apt_123456",
      patient_id: "pat_123456",
      original_time: "2026-04-05T09:00:00Z",
      new_time: "2026-04-06T14:00:00Z",
      reason: "Patient request"
    }
  },
  "appointment.cancelled": {
    event_type: "appointment.cancelled",
    data: {
      appointment_id: "apt_123456",
      patient_id: "pat_123456",
      cancelled_at: "2026-04-04T11:00:00Z",
      reason: "Schedule conflict",
      cancelled_by: "patient"
    }
  },

  // Communication Events
  "chat.message.received": {
    event_type: "chat.message.received",
    data: {
      message_id: "msg_123456",
      conversation_id: "conv_789",
      sender_id: "usr_123",
      recipient_id: "usr_456",
      message_type: "text",
      content: "Hello, I have a question about my appointment.",
      sent_at: "2026-03-31T10:30:00Z"
    }
  },
  "voip.call.started": {
    event_type: "voip.call.started",
    data: {
      call_id: "call_123456",
      caller_id: "usr_123",
      callee_id: "usr_456",
      call_type: "video",
      started_at: "2026-03-31T10:30:00Z"
    }
  },
  "voip.call.ended": {
    event_type: "voip.call.ended",
    data: {
      call_id: "call_123456",
      caller_id: "usr_123",
      callee_id: "usr_456",
      duration_seconds: 300,
      ended_at: "2026-03-31T10:35:00Z",
      end_reason: "completed"
    }
  },

  // Payment Events
  "payment.completed": {
    event_type: "payment.completed",
    data: {
      payment_id: "pay_123456",
      patient_id: "pat_123456",
      amount: 150.00,
      currency: "USD",
      payment_method: "credit_card",
      description: "Dental checkup fee",
      completed_at: "2026-03-31T10:30:00Z"
    }
  },
  "invoice.generated": {
    event_type: "invoice.generated",
    data: {
      invoice_id: "inv_123456",
      patient_id: "pat_123456",
      amount: 500.00,
      currency: "USD",
      line_items: [
        { description: "Dental implant", amount: 450.00 },
        { description: "X-ray", amount: 50.00 }
      ],
      due_date: "2026-04-15",
      generated_at: "2026-03-31T10:30:00Z"
    }
  },
  "subscription.started": {
    event_type: "subscription.started",
    data: {
      subscription_id: "sub_123456",
      user_id: "usr_123456",
      plan: "premium",
      amount: 29.99,
      currency: "USD",
      billing_cycle: "monthly",
      started_at: "2026-03-31T10:30:00Z"
    }
  },
  "subscription.cancelled": {
    event_type: "subscription.cancelled",
    data: {
      subscription_id: "sub_123456",
      user_id: "usr_123456",
      plan: "premium",
      cancelled_at: "2026-03-31T10:30:00Z",
      reason: "No longer needed",
      effective_end_date: "2026-04-30"
    }
  },

  // App Events
  "app.created": {
    event_type: "app.created",
    data: {
      app_id: "app_123456",
      name: "My Dental App",
      developer_id: "dev_789",
      created_at: "2026-03-31T10:30:00Z"
    }
  },
  "app.updated": {
    event_type: "app.updated",
    data: {
      app_id: "app_123456",
      name: "My Dental App v2",
      updated_fields: ["name", "description", "version"],
      updated_at: "2026-03-31T10:30:00Z"
    }
  },
  "app.subscribed": {
    event_type: "app.subscribed",
    data: {
      app_id: "app_123456",
      user_id: "usr_789",
      plan: "pro",
      subscribed_at: "2026-03-31T10:30:00Z"
    }
  },
  "app.unsubscribed": {
    event_type: "app.unsubscribed",
    data: {
      app_id: "app_123456",
      user_id: "usr_789",
      reason: "Switching to different solution",
      unsubscribed_at: "2026-03-31T10:30:00Z"
    }
  },
  "app.payment.success": {
    event_type: "app.payment.success",
    data: {
      app_id: "app_123456",
      user_id: "usr_789",
      payment_id: "pay_123456",
      amount: 49.99,
      currency: "USD"
    }
  },
  "app.payment.failed": {
    event_type: "app.payment.failed",
    data: {
      app_id: "app_123456",
      user_id: "usr_789",
      amount: 49.99,
      currency: "USD",
      failure_reason: "Card declined"
    }
  },
  "app.review.submitted": {
    event_type: "app.review.submitted",
    data: {
      app_id: "app_123456",
      user_id: "usr_789",
      review_id: "rev_123456",
      rating: 5,
      comment: "Great app, very helpful!",
      submitted_at: "2026-03-31T10:30:00Z"
    }
  },
  "app.review.deleted": {
    event_type: "app.review.deleted",
    data: {
      app_id: "app_123456",
      review_id: "rev_123456",
      deleted_at: "2026-03-31T10:30:00Z",
      reason: "User request"
    }
  }
};

// Get payload schema for a specific event type
export const getPayloadSchema = (eventType) => {
  return WRITEBACK_PAYLOAD_SCHEMAS[eventType] || {
    event_type: eventType,
    data: {
      // Generic placeholder
      id: "resource_123456",
      timestamp: "2026-03-31T10:30:00Z"
    }
  };
};

// Get combined payload example for multiple event types
export const getCombinedPayloadExample = (eventTypes) => {
  if (!eventTypes || eventTypes.length === 0) return null;
  
  // Return examples for each event type
  return eventTypes.map(et => getPayloadSchema(et));
};
